/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { ccDisplayKey, DisplayKey } from '../../Game/DisplayKey';
import { ccCultureID, CultureID } from '../../Localization/CultureID';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass("OptionalDefinition")
export default class OptionalDefinition
{
    @property({ type: ccDisplayKey })
    public DisplayKey: DisplayKey = DisplayKey.ForWager;

    @property()
    public LanguageSpecific: boolean = false;

    @property({ type: ccCultureID, visible: (function(): boolean { return this.LanguageSpecific; }) })
    public Language: CultureID = CultureID.en_us;
}
